import { Store } from '@ngrx/store';
import { IEntityService, EntityFacade, IBaseEnvironment, QueryFacade, IQueryService } from '@kpd/framework-ngx';

export abstract class UserManagementEntityFacade extends EntityFacade {
  constructor(
    public entityStateName: string,
    protected store: Store<any>,
    public entityService: IEntityService,
    protected environment: IBaseEnvironment,
  ) {
    super(entityStateName, store, entityService, environment);
    this.localSearch = true;
  }
}

export abstract class UserManagementQueryFacade extends QueryFacade {
  constructor(
    public entityStateName: string,
    protected store: Store<any>,
    public entityService: IQueryService,
    protected environment: IBaseEnvironment,
  ) {
    super(entityStateName, store, entityService, environment);
    this.localSearch = true;
  }
}
